import type { GroupedUsersList } from '@halo/ui-chat-react';
import type { User } from '@halo/chat-sdk-react';
import { useDeferredValue, useEffect, useMemo, useState } from 'react';
import { useDebounceFn } from 'ahooks';

export const useSearch = (
  searchValue: string,
  resetTrigger: number,
  isOpen: boolean,
  members: User[]
) => {
  const value = useDeferredValue(searchValue);
  const [normalMembers, setNormalMembers] = useState<GroupedUsersList[]>([]);

  const list = useMemo(() => {
    return [...normalMembers];
  }, [normalMembers]);

  const { run: onSearch } = useDebounceFn(
    async () => {
      const filteredNormalMembers = members?.filter((member) => member.name.includes(value));
      setNormalMembers([{ items: filteredNormalMembers ?? [] }]);
    },
    { wait: 300 }
  );

  useEffect(() => {
    if (isOpen) {
      onSearch();
    }
  }, [value, onSearch, isOpen]);

  useEffect(() => {
    if (resetTrigger !== undefined) {
      setNormalMembers([]);
    }
  }, [resetTrigger]);

  return { onSearch, normalMembers, list };
};
